// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"cf6b96ce","67":"410737fe","100":"2abbd35d","111":"25a7d38c","175":"8d4822c6","236":"f8023ed3","300":"604b8926","452":"65bd07a1","606":"10c7dd56","673":"d3707646","738":"5f256a18","867":"98e08aa1","985":"d8e0f3f7"}[chunkId] + ".chunk.js";
};